import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
// Copies the text content of the "source" target to the clipboard, flashing the
// trigger button label to confirm success or failure.
export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    const button = event.currentTarget;
    navigator.clipboard.writeText(this.sourceTarget.textContent.trim()).then(() => {
      this.flash(button, window.I18n["views.admin.case_studies.show.referee_url.copied"]);
    }).catch(() => {
      this.flash(button, window.I18n["views.admin.case_studies.show.referee_url.copy_failed"]);
    });
  }

  flash(button, message) {
    const original = button.textContent;
    button.textContent = message;
    setTimeout(() => { button.textContent = original; }, 2000);
  }
}
